import { Accordion } from "radix-ui";

export const AccordionItem = ({ children, ...props }) => {
  return (
    <Accordion.Item className="border-b" {...props}>
      {children}
    </Accordion.Item>
  );
};
